import moment from "moment";
import { capitalizeFirstLetter } from "@/utils";

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const getMonthNameFromNumber = (
  monthNumber: number,
  gettext?: (key: string) => string,
) => {
  const englishMonth = MONTH_NAMES[monthNumber - 1];
  if (gettext && englishMonth) {
    return gettext(englishMonth);
  }
  return capitalizeFirstLetter(
    moment()
      .month(monthNumber - 1)
      .format("MMMM"),
  );
};
